import { Component } from '@angular/core';

@Component({
  selector: 'app-incidents-import-detail-header',
  templateUrl: './incidents-import-detail-header.component.html',
  styleUrls: ['./incidents-import-detail-header.component.scss']
})
export class IncidentsImportDetailHeaderComponent {

}
